import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderSlot as _renderSlot, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-062a37e3")
const _hoisted_1 = { class: "p-d-flex p-jc-between p-mb-4" }
const _hoisted_2 = { class: "p-input-icon-left" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-search" }, null, -1)
const _hoisted_4 = { class: "p-grid p-jc-between p-ai-center p-nogutter" }
const _hoisted_5 = { class: "p-col-10 p-d-flex p-ai-center" }
const _hoisted_6 = { class: "p-col-auto" }
const _hoisted_7 = ["onClick"]
const _hoisted_8 = { key: 0 }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("h4", { style: {"margin":"0"} }, "Cursos que la componen", -1)
const _hoisted_10 = { class: "courses-list" }
const _hoisted_11 = ["href"]
const _hoisted_12 = {
  key: 0,
  class: "pi pi-check"
}
_popScopeId()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputText = _resolveComponent("InputText")!
  const _component_BrainSpinner = _resolveComponent("BrainSpinner")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Column = _resolveComponent("Column")!
  const _component_DataTable = _resolveComponent("DataTable")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _createVNode(_component_InputText, {
          disabled: _ctx.loading,
          modelValue: _ctx.filters['global'].value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_ctx.filters['global'].value = $event)),
          placeholder: "Buscar"
        }, null, 8, ["disabled", "modelValue"])
      ]),
      _createElementVNode("div", null, [
        _renderSlot(_ctx.$slots, "top-right-content", {}, undefined, true)
      ])
    ]),
    (_ctx.loading)
      ? (_openBlock(), _createBlock(_component_BrainSpinner, { key: 0 }))
      : (_openBlock(), _createBlock(_component_DataTable, {
          key: 1,
          class: "content-table gray-table borders-white",
          value: _ctx.data,
          filters: _ctx.filters,
          "onUpdate:filters": _cache[1] || (_cache[1] = ($event: any) => (_ctx.filters = $event)),
          globalFilterFields: ['information.name']
        }, {
          default: _withCtx(() => [
            _createVNode(_component_Column, {
              filterField: "information.name",
              style: {"width":"35%"},
              header: "Curso / Carrera",
              field: "information.name"
            }, {
              body: _withCtx(({ data: { information, courses }, data }) => [
                _createElementVNode("div", _hoisted_4, [
                  _createElementVNode("div", _hoisted_5, [
                    _createVNode(_component_Button, {
                      onClick: ($event: any) => (_ctx.$router.push({
                name: !courses?.length
                ? _ctx.EducationRouteNames.CONTENT_COURSES_DETAIL_SYLLABUM
                : _ctx.EducationRouteNames.CONTENT_CAREERS_DETAIL_GENERAL_INFO,
                params: {
                  planId: data.id
                }
              })),
                      class: "p-button-sm p-button-text p-mr-2",
                      icon: "pi pi-pencil"
                    }, null, 8, ["onClick"]),
                    _createTextVNode(" " + _toDisplayString(information.name), 1)
                  ]),
                  _createElementVNode("div", _hoisted_6, [
                    (courses?.length)
                      ? (_openBlock(), _createElementBlock("i", {
                          key: 0,
                          onClick: ($event: any) => (_ctx.toggleExpand(data)),
                          class: _normalizeClass(_ctx.expandedRows.includes(data) ? 'pi pi-angle-up': 'pi pi-angle-down')
                        }, null, 10, _hoisted_7))
                      : _createCommentVNode("", true)
                  ])
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_Column, { style: {"width":"40%"} }, {
              body: _withCtx(({ data }) => [
                (_ctx.expandedRows.includes(data))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                      _hoisted_9,
                      _createElementVNode("ul", _hoisted_10, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data.courses, (course) => {
                          return (_openBlock(), _createElementBlock("li", { key: course }, [
                            _createElementVNode("a", {
                              href: course.url,
                              target: "_blank"
                            }, _toDisplayString(course.information.name), 9, _hoisted_11)
                          ]))
                        }), 128))
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }),
            _createVNode(_component_Column, {
              style: {"width":"auto"},
              header: "Publicado",
              field: "published",
              bodyStyle: "text-align: center",
              headerClass: "column-title-centered"
            }, {
              body: _withCtx(({ data: { published } }) => [
                published
                  ? (_openBlock(), _createElementBlock("i", _hoisted_12))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }),
            _createVNode(_component_Column, {
              style: {"width":"auto"},
              header: "URL",
              field: "url",
              bodyStyle: "text-align: center",
              headerClass: "column-title-centered"
            }, {
              body: _withCtx(({ data: { links: { path } } }) => [
                _createVNode(_component_Button, {
                  onClick: ($event: any) => (_ctx.window.open(`https://www.coderhouse.com/online/${path}`, '_blank')),
                  class: "p-button-primary p-button-text",
                  disabled: !path,
                  icon: "pi pi pi-external-link"
                }, null, 8, ["onClick", "disabled"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["value", "filters", "globalFilterFields"]))
  ], 64))
}